import { ReduceStore } from "flux/utils";
import AppDispatcher from "../AppDispatcher";
import CurrentOrganizationStore from "./CurrentOrganizationStore";
import CurrentUserStore from "./CurrentUserStore";
import CurrentRoleStore from "./CurrentRoleStore";
import ProfileStore from "./ProfileStore";

class ApplicationReadyStore extends ReduceStore {
  getInitialState() {
    return false;
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      CurrentOrganizationStore.getDispatchToken(),
      CurrentUserStore.getDispatchToken(),
      ProfileStore.getDispatchToken(),
      CurrentRoleStore.getDispatchToken(),
    ]);

    if (
      CurrentOrganizationStore.hasChanged() ||
      CurrentUserStore.hasChanged() ||
      ProfileStore.hasChanged() ||
      CurrentRoleStore.hasChanged()
    ) {
      return !!(
        CurrentOrganizationStore.getState() &&
        CurrentUserStore.getState() &&
        ProfileStore.getState() &&
        CurrentRoleStore.getState()
      );
    }

    return state;
  }
}

const instance = new ApplicationReadyStore(AppDispatcher);
export default instance;
